export default __webpack_public_path__ + "static/git-bcd603f8e4b7efd68c0759aa8949d95d.png";